import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { isUndefined } from 'util';
import { LoginAndUserManagerService } from '../../../api/managers/login-and-user-manager.service';

@Component({
    selector: 'app-registration-resend-validation',
    templateUrl: './registration-resend-validation.component.html',
    styleUrls: ['./registration-resend-validation.component.less']
})
export class RegistrationResendValidationComponent implements OnInit
{

    validationEmail;
    error;

    isLoading = false;

    constructor(private loginAndUserManagerService: LoginAndUserManagerService,
                private router: Router)
    { }

    ngOnInit()
    {
        this.validationEmail = (this.router.parseUrl(this.router.url)).queryParams.email;
        if (!isUndefined(this.validationEmail))
        {
            this.send(this.validationEmail);
        }
    }

    goToMain()
    {
        this.router.navigate(['/welcome']);
    }

    resendValidationEmail(resendForm: NgForm)
    {
        this.send(resendForm.value.validationEmail);
    }

    send(email: string)
    {
        this.isLoading = true;
        this.loginAndUserManagerService.sendConfirmationEmail(email).subscribe(res =>
        {
            this.isLoading = false;
            this.router.navigate(['register/success'], { queryParams: { email: email } });
        }, err =>
        {
            this.isLoading = false;
            if (err.status === 200)
            {
                this.router.navigate(['register/success'], { queryParams: { email: email } });
                return;
            }
            this.error = err.error.ModelState.Error;
        });
    }

}
